var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtagsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92.2c.26.06.42.31.36.57L2.91 11.44a.48.48 0 1 1-.93-.21L4.35.56A.48.48 0 0 1 4.92.2ZM9.66.2c.26.06.43.31.37.57L7.66 11.44a.48.48 0 0 1-.94-.21L9.09.56A.48.48 0 0 1 9.66.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.78 3.63c0-.26.22-.48.48-.48h10.07a.48.48 0 0 1 0 .96H1.26a.48.48 0 0 1-.48-.48ZM.19 8.37c0-.27.21-.48.48-.48h10.07a.48.48 0 0 1 0 .96H.67a.48.48 0 0 1-.48-.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagsmall);
export default __webpack_public_path__ + "static/media/hashtag.small.71cbf7e1bddff0559b3e66a0c0b170d0.svg";
export { ForwardRef as ReactComponent };